const colors = {
	primary: "#f59f00",
};

export default colors;
